/**
 * What the team page (/team) tells search engines and link previews — ONE copy, read by today's page
 * (src/pages/TeamExpertise.tsx) and its rebuild in the new design, the way src/config/startSeo.ts serves both start
 * pages (design record §7b).
 *
 * THE SHAPE IS READ BY THE GUEST CHAT'S KNOWLEDGE SOURCE (scripts/generate-guest-knowledge-source.mjs lists this file
 * for "/team"): its extractor takes a `title:` / `description:` field whose string sits on the same line, so each
 * stays one line.
 */
export const TEAM_SEO = {
  title: 'Team | prest0',
  tabTitle: 'team',
  description: "Meet the team behind prest0's enterprise AI employees platform for law and finance—experts in AI, operations, and large-scale platform development.",
  keywords: 'prest0 team, enterprise AI employees, AI platform team, law finance AI, enterprise automation leadership',
  canonicalUrl: 'https://prest0.ai/team',
  schemaType: 'WebPage',
} as const;
